import { ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { api } from '@/api/client';
/**
 * Fetches and caches the dashboard summary from GET /v1/dashboard/summary.
 * Refresh calls are debounced to 500ms so that rapid SignalR invalidation
 * events don't produce a thundering herd of parallel requests.
 *
 * The endpoint does not yet exist in the generated schema (Agent A's work);
 * we call it via the raw api client using `as any` until `pnpm openapi:gen`
 * runs against Agent A's merged branch and adds the path to schema.d.ts.
 */
const summary = ref(null);
const isLoading = ref(false);
const lastRefreshedAt = ref(null);
async function fetchSummary() {
    isLoading.value = true;
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data, error } = await api.GET('/v1/dashboard/summary');
        if (error) {
            console.error('[useDashboardSummary] fetch error', error);
            return;
        }
        summary.value = data;
        lastRefreshedAt.value = new Date();
    }
    catch (err) {
        console.error('[useDashboardSummary] unexpected error', err);
    }
    finally {
        isLoading.value = false;
    }
}
const refresh = useDebounceFn(fetchSummary, 500);
export function useDashboardSummary() {
    return { summary, isLoading, lastRefreshedAt, refresh };
}
